import $ from 'jquery';
import Calculator from "../catcalc/calculator";

export default {
  init() {
    let form = $('.catcal--form');

    form.parent().append(`<div class="catcal--estimate"><h4><small>current estimate</small></h4><h2 id="calcEstimate" class="estimate"></h2></div>`);

    form.find('.catcal--summary')
      .append(`<table class="table catcalc--summary">
                   <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th class="text-center">Price</th>
                        </tr>
                   </thead>
                   <tbody>
                        <tr>
                          <td colspan="2" class="col-md-10 catcalc--summary-food"><h3>Food</h3></td>
                        </tr>
                        <tr class="catcalc--summary-food-appetizers">
                            <td class="col-md-9"><em><h4>Appetizers</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>
                        <tr class="catcalc--summary-food-entrees">
                            <td class="col-md-9"><em><h4>Entrees</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>
                        <tr class="catcalc--summary-food-dessert">
                            <td class="col-md-9"><em><h4>Dessert</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>                        
                        
                        <tr>
                          <td colspan="2" class="col-md-10 catcalc--summary-beverages"><h3>Beverages</h3></td>
                        </tr>
                        <tr class="catcalc--summary-beverages-nonalcoholic">
                            <td class="col-md-9"><em><h4>Non-Alcoholic Beverages</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>                        
                        <tr class="catcalc--summary-beverages-bar">
                            <td class="col-md-9"><em><h4>Bar Service</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>   
                          <tr>
                          <td colspan="2" class="col-md-10 catcalc--summary-service"><h3>Service</h3></td>
                        </tr>
                        <tr>
                            <td class="col-md-9"><em><h4>Staff</h4><span class=""></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="catcalc--summary-staff"></span></h5></td>
                        </tr>                        
                        <tr class="catcalc--summary-staff-servers">
                            <td class="col-md-9 text-right"><em><strong>Servers</strong></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="count"></span></h5></td>
                        </tr>                        
                        <tr class="catcalc--summary-staff-bartenders">
                            <td class="col-md-9 text-right"><em><strong>Bartenders</strong></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="count"></span></h5></td>
                        </tr>   
                                            
                        <tr>
                          <td colspan="2" class="col-md-10 catcalc--summary-rentals"><h3>Rentals</h3></td>
                        </tr>
                        <tr class="catcalc--summary-rentals-tables">
                            <td class="col-md-9"><em><h4>Rent chairs, tables, and linens?</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>                        
                        <tr class="catcalc--summary-rentals-dishes">
                            <td class="col-md-9"><em><h4>Rent china, dishware, and flatware?</h4><span class="choice"></span></em></td>
                            <td class=  "col-md-1 text-center"><h5><span class="cost"></span></h5></td>
                        </tr>   
                                                
                        <tr>
                            <td class="text-right"><h4><strong>Fees:&nbsp;</strong></h4></td>
                            <td class="text-center text-danger"><h4><strong><span class="catcalc--summary-fees"></span></strong></h4></td>
                        </tr>
                        <tr>
                            <td class="text-right"><h4><strong>Total:&nbsp;</strong></h4></td>
                            <td class="text-center text-danger"><h4><strong><span class="catcalc--summary-total"></span></strong></h4></td>
                        </tr>                        
                   </tbody>
               </table>`);

  /*
  <table>
                      <tr><th>Food</th> <td class="catcalc--summary-food"></td></tr>
                      <tr><th>Beverages</th> <td class="catcalc--summary-beverages"></td></tr>
                      <tr><th>Service</th> <td class="catcalc--summary-service"></td></tr>
                      <tr><th>Rentals</th> <td class="catcalc--summary-rentals"></td></tr>
                      <tr><th>Staff</th> <td class="catcalc--summary-staff"></td></tr>
                      <tr><th>  Servers</th> <td class="catcalc--summary-staff-servers"></td></tr>
                      <tr><th>  Bartenders</th> <td class="catcalc--summary-staff-bartenders"></td></tr>

                      <tr><th>Fees</th><th class="catcalc--summary-fees"></th></tr>
                      <tr><th>Total</th><th class="catcalc--summary-total"></th></tr>
                    </table>
   */

    // eslint-disable-next-line no-unused-vars
    let calculator = new Calculator(form);


  },
  finalize() {

  },

}



// WEBPACK FOOTER //
// ./scripts/routes/catCalc.js